module.exports = __webpack_public_path__ + "public/img/jingyuetang_logo.1df2ebf5.png";